export default class MainNav {
  constructor({ el }) {
    this.el = el;
    this.navInner = this.el.querySelector('.main-nav');
    this.childrenButtons = Array.from(this.el.querySelectorAll('.main-links .has-children'));
    this.subMenus = Array.from(this.el.querySelectorAll('.sub-menu'));

    // mobile menu
    this.menuOpeners = Array.from(this.el.querySelectorAll('.menu-opener'));
    this.mobileMenu = document.getElementById('mobile-menu');
    this.menuClosers = Array.from(this.mobileMenu.querySelectorAll('.menu-closer'));
    this.mainMobileMenuButton = document.getElementById('main-mobile-menu-button');

    // scroll watch
    this.lastScrollTop = 0;
    this.trigger = 250;

    this.init();
  }

  init() {
    this.setWatch();

    this.childrenButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const title = button.dataset.title;
        const subMenu = this.subMenus.find((subMenu) => subMenu.dataset.title === title);

        if (subMenu && subMenu.classList.contains('active')) {
          subMenu.classList.remove('active');
          this.navInner.classList.remove('sub-menu-active');
        } else if (subMenu) {
          this.subMenus.forEach((subMenu) => {
            subMenu.classList.remove('active');
          });

          subMenu.classList.add('active');
          this.navInner.classList.add('sub-menu-active');
        }
      });
    });

    this.menuOpeners.forEach((opener) => {
      opener.addEventListener('click', (e) => {
        e.preventDefault();

        if (document.body.classList.contains('mobile-menu-active')) {
          document.body.classList.remove('mobile-menu-active');
          document.body.style.overflow = 'initial';
          this.mainMobileMenuButton.innerHTML = 'Menu';
        } else {
          document.body.classList.add('mobile-menu-active');
          document.body.style.overflow = 'hidden';
          this.mainMobileMenuButton.innerHTML = 'Close';
        }
      });
    });

    this.menuClosers.forEach((closer) => {
      closer.addEventListener('click', (e) => {
        e.preventDefault();

        document.body.classList.remove('mobile-menu-active');
        document.body.style.overflow = 'initial';
      });
    });

    // show nav if hovering near top
    this.el.addEventListener('mouseenter', () => {
      if (document.body.classList.contains('hide-nav')) {
        this.showNav();
      }
    });
  }

  // method to show nav
  showNav() {
    document.body.classList.remove('hide-nav');
  }

  // method to hide nav
  hideNav() {
    document.body.classList.add('hide-nav');
  }

  setWatch() {
    window.addEventListener('scroll', this.watch.bind(this), { passive: true });
  }

  watch() {
    let st = window.scrollY; // get scroll top

    if (st > 50) {
      if (!document.body.classList.contains('scrolled')) {
        document.body.classList.add('scrolled');
      }
    } else {
      if (document.body.classList.contains('scrolled')) {
        document.body.classList.remove('scrolled');
      }
    }

    // if scroll top is less than trigger, show the nav
    if (this.lastScrollTop < this.trigger) {
      this.showNav();
    } else {
      // if scroll top is greater than trigger, show or hide nav based on scroll direction
      st > this.lastScrollTop ? this.hideNav() : this.showNav();
    }

    // set last scroll top
    this.lastScrollTop = st <= 0 ? 0 : st;
  }
}
